import { getAccessToken } from './auth';
import { handleUnauthorized } from './tokenRefresh';

// ─── Core request with auth + silent refresh ──────────────────────────────────
const apiRequest = async (url, options = {}) => {
  const makeRequest = (accessToken) => fetch(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
      ...options.headers,
    },
  });

  let response = await makeRequest(getAccessToken());

  if (response.status === 401) {
    const newToken = await handleUnauthorized(); // shared — won't double-refresh
    response = await makeRequest(newToken);
  }

  if (!response.ok) {
    const json = await response.json().catch(() => ({}));
    throw new Error(json.message || `HTTP error! status: ${response.status}`);
  }

  return response.json();
};

// ─── Helpers ──────────────────────────────────────────────────────────────────
export const get  = (url)       => apiRequest(url);
export const post = (url, data) => apiRequest(url, { method: 'POST', body: JSON.stringify(data) });
